export const toFilterString = (value: number | null | undefined): string | null =>
  value == null ? null : String(value);
